module.exports = __webpack_public_path__ + "static/img/5.a9f0a35.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/4/1/zh/5.png
// module id = kesB
// module chunks = 0